module.exports = __webpack_public_path__ + "img/组 78@2x.c976e2b5.png";